import type { Annotation } from "@rowan/prisma";
import { createContext } from "react";

type AnnotationContextType = {
  annotations?: Annotation[];
  annotationsOpen: boolean;
  setAnnotationsOpen: (open: boolean) => void;
  focusedId?: string;
  setFocusedId: (id?: string) => void;
  didTapMenuRef?: React.RefObject<boolean>;
};

export const AnnotationContext = createContext<AnnotationContextType>({
  annotationsOpen: false,
  setAnnotationsOpen: () => {},
  setFocusedId: () => {},
});
